<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="center-para"><a id="page_i"></a><strong>Praise for Louisa Edwards</strong></p>
<p class="para"> </p>
<p class="center-para"><span class="font">Can’t Stand the Heat</span></p>
<p class="para"> </p>
<p class="para">“Exceptional culinary detail and page-singeing sexual chemistry combine with a fascinating group of characters to produce a sophisticated modern romance that ties into the current foodie craze. This debut—first in a projected ‘Recipe for Love’ series—will win over most contemporary romance fans.”</p>
<p class="right-para"><em>—Library Journal</em></p>
<p class="para"> </p>
<p class="para">“In her wickedly entertaining debut, Edwards dishes up a captivating contemporary romance expertly seasoned with plenty of sizzling sexual chemistry and deliciously tart humor.”</p>
<p class="right-para"><em>—Booklist</em></p>
<p class="para"> </p>
<p class="para">“The simmering chemistry comes to a boil in this deliciously sensual and delightfully amusing debut.”</p>
<p class="right-para"><em>—Orlando Sentinel</em></p>
<p class="para"> </p>
<p class="para">“This playful culinary confection is a lighthearted and entertaining romance that will delight readers. With all the behind-the-scenes revelations, you’ll never look at cooking and meal preparation in the same way again. Steamy and satisfying fare, indeed.”</p>
<p class="right-para"><em>—Fresh Fiction</em></p>
<p class="para"> </p>
<p class="para">“I LOVED <em>Can’t Stand the Heat</em>. Louisa Edwards has written a great debut novel, and I look forward to reading more of the Recipe for Love series.”</p>
<p class="right-para"><em>—Beautiful Reads</em></p>
<p class="para"> </p>
<p class="para">“A deliciously fun read. The plot and eccentric characters are well written, and the kitchen sizzles with hot passion.”</p>
<p class="right-para"><em>—Romance Reviews Today</em></p>
<p class="para">“Snappy, exciting, adventurous, and totally unexpected. <em>Can’t Stand the Heat</em> . . . is one of the best light-hearted culinary <a id="page_ii"></a>romantic novels this reviewer has read in a very long time! Grand job, Louisa Edwards.”</p>
<p class="right-para"><em>—Crystal Reviews</em></p>
<p class="para"> </p>
<p class="para"><em>“Can’t Stand the Heat</em> is the first novel in her Recipe for Love series, and what a start it is. All of the characters are portrayed in such a revealing light that you will remember them for quite some time. I love the sensuality as well as the conflict. I have become a fan of this author and cannot wait to read more in her series, along with any other works she comes out with!”</p>
<p class="right-para"><em>—Coffee Time Romance</em> (5 Stars)</p>
<p class="para"> </p>
<p class="para">“Make sure that you have a good lazy day to spend with <em>Can’t Stand the Heat</em>, and don’t start reading this one in the evening, or I guarantee you will be up all night!”</p>
<p class="right-para"><em>—The Romance Reader</em></p>
<p class="para"> </p>
<p class="para">“The author blends love and recipes into a fun romp…Fans will enjoy the pizazz and flavor that Louisa Edwards brings to her warm tale.”</p>
<p class="right-para"><em>—Genre Go Round Reviews</em></p>
<p class="para"> </p>
<p class="para">“A funny, lovable story about two unlikely people falling for each other. The plot, characters, and setting come together to form a wonderful, light-hearted, culinary romance that is a blast to read . . . I can’t wait for the next Recipe for Love novel!”</p>
<p class="right-para"><em>—The Book Lush</em></p>
<p class="para"> </p>
<p class="para"><a id="page_iii"></a>“Delish! Creative debut author Louisa Edwards will have you eating out of her hand as you read her witty, insightful, foodie romance . . .<em>Can’t Stand the Heat</em> is filled with steamy passion, realistically described settings, a distinctive plot and characters that beg for their own stories. Watch for more to come from this talented new author.”</p>
<p class="right-para">—<a href="http://SingleTitles.com" target="_blank">SingleTitles.com</a></p>
<p class="para"> </p>
<p class="para">“The main characters felt like friends and the secondary romance involving Miranda’s brother helped keep things moving. One of the best parts was discovering an excerpt of Edwards’s next book featuring a minor character from this one—giving me another book to look forward to…<em>Can’t Stand the Heat?</em> I say, get into this kitchen!”</p>
<p class="right-para">—<a href="http://PublishersWeekly.com" target="_blank">PublishersWeekly.com</a></p>
<p class="para"> </p>
<p class="para">“An exquisitely prepared romance seasoned with scorching hot love scenes, <em>Can’t Stand the Heat</em> is truly an unforgettable dish. You can’t miss this delectable and mouthwatering debut!”</p>
<p class="right-para"><em>—New York Times</em> bestselling author Kresley Cole</p>
<p class="para"> </p>
<p class="para">“Smokin’ hot chefs, sizzling passion, and a big dash of charm—no reservations required for this smart, stylish romance!”</p>
<p class="right-para"><em>—New York Times</em> bestselling author</p>
<p class="right-para">Gena Showalter</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?6289611e